/**
 * Copyright © 2026 Adnuntius AS.
 *
 * Creative asset upload/preview chrome and mime/size/transcode output.
 */
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {TranslateModule} from '@ngx-translate/core';
import {BsDropdownModule} from 'ngx-bootstrap/dropdown';

import {AppSharedModule} from '../common/app-shared.module';
import {FileUploadComponent} from '../common/directives/file-upload/file-upload.component';
import {AssetRenderComponent} from '../common/directives/html/asset-render-component';
import {AssetTranscodeComponent} from '../common/directives/html/asset-transcode-component';
import {TranscodeConfigComponent} from '../common/directives/transcode-config-component';
import {PixelDimensionsOutputComponent} from '../common/directives/pixel-dimensions-output-component';
import {MimeTypeOutputComponent} from '../common/directives/mime-type-output-component';
import {GuardTypePipe} from '../common/filters/guard-type.pipe';
import {MimeTypeKeyPipe} from '../common/filters/mime-type-key.pipe';
import {AssetsComponent} from './asset/assets.component';
import {AssetComponent} from './asset/asset.component';
import {VideoAssetsComponent} from './asset/video-assets.component';
import {FileSizeOutputComponent} from './asset/file-size-output-component';

const CREATIVE_ASSETS = [
  FileUploadComponent,
  AssetsComponent,
  AssetComponent,
  VideoAssetsComponent,
  AssetRenderComponent,
  AssetTranscodeComponent,
  TranscodeConfigComponent,
  FileSizeOutputComponent,
  PixelDimensionsOutputComponent,
  MimeTypeOutputComponent,
  GuardTypePipe,
  MimeTypeKeyPipe
];

@NgModule({
  imports: [
    AppSharedModule,
    FormsModule,
    TranslateModule,
    BsDropdownModule
  ],
  declarations: CREATIVE_ASSETS,
  exports: CREATIVE_ASSETS
})
export class CreativeAssetsModule {
}
